<sm-confirmation-dialog
  [isOpen]="isOpen"
  panelVariant="form"
  dialogType="information"
  heroIconName="information-circle-outline"
  confirmTone="primary"
  [title]="'webVersionHint.title' | translate"
  [confirmationText]="''"
  [cancelLabel]="'auth.common.closeButton' | translate"
  [confirmLabel]="'webVersionHint.dismiss' | translate"
  [closeLabel]="'auth.common.closeButton' | translate"
  [compactActions]="true"
  (cancelRequest)="hint.close()"
  (confirmRequest)="hint.dismissInstalledVersion()">
  <p class="web-version-message">
    {{ 'webVersionHint.message' | translate }}
    <a href="https://invemory.com" (click)="openWebVersion($event)">{{ 'webVersionHint.openWebVersion' | translate }}</a>{{ 'webVersionHint.suffix' | translate }}
  </p>
</sm-confirmation-dialog>
